import { IAjaxHelperConfig } from './iajax_helper_config';
import { Util } from '../common_utils/util';
// import logger from 'logger_module';
import { OauthClient } from './oauth_client';
import { OnlineCheckHelper } from '../common_utils/online_check_helper';

import { AjaxHelper } from './ajax_helper';
import { AjaxHelperConfig } from './ajax_helper_config';
//import * as $ from 'jquery';


/**
 * Responsible to handle all the Ajax FAILURE cases, generated in the AjaxHelper object. 
 * @export
 * @class AjaxFailureHelper
 */
export class AjaxFailureHelper {

    private options: IAjaxHelperConfig['options'];
    private requestConfig: IAjaxHelperConfig['requestConfig'];
    private failedReponse: { jqXHR: any, textStatus: string, errorThrown: string, errorCode?: string };
    private ajaxHelperModule: AjaxHelper;
    constructor(ajaxHelperModule: AjaxHelper) {
        this.ajaxHelperModule = ajaxHelperModule;
        this.options = ajaxHelperModule.getAjaxHelperConfig().options;
        this.requestConfig = ajaxHelperModule.getAjaxHelperConfig().requestConfig;
        this.failedReponse = { jqXHR: {}, textStatus: '', errorThrown: '', errorCode: '' };// assigning default value
    }

    ajaxFailureCallback(failedReponse: { jqXHR: any, textStatus: string, errorThrown: string, errorCode?: string }) {
        this.failedReponse = failedReponse;
        let statusCode: number = parseInt(this.failedReponse.jqXHR.status, 10);

        // Assets API is not setting cors header, and now getting the correct responseText so using that to identify the status code, mainly 401 to call refresh tocken call
        if (statusCode === 0 && this.failedReponse.jqXHR.responseText && this.failedReponse.jqXHR.responseText.error) {
            statusCode = parseInt(this.failedReponse.jqXHR.responseText.error, 10);
        }

        this.setErrorCode(statusCode);
        // Used to LOG both Request and Response data for all failed API calls in both Uploader, ingestion and library flows
        const { requestDetails, responseDetails } =
            this.captureRequestResponseDetails(this.failedReponse.jqXHR.responseText, statusCode);
        this.logIt(statusCode, responseDetails, requestDetails);

        // public share landing page case
        const options = this.ajaxHelperModule.getAjaxHelperConfig().options;
        if (options && options.isAuthorizationRequired === false) {
            this.ajaxHelperModule.getAjaxHelperConfig().getPromiseRef().reject({
                errorType : "API_FAILURE",
                httpStatusCode: statusCode,
                apiUrl: this.ajaxHelperModule.getAjaxHelperConfig().requestConfig.url,
                jqXHR: this.failedReponse.jqXHR, textStatus: this.failedReponse.textStatus,
                errorThrown: this.failedReponse.errorThrown, noodle: this.ajaxHelperModule.getAjaxHelperConfig().getNoodle()
            });
            return;
        }
        this.handleStatusCodes(requestDetails);
    }

    private captureRequestResponseDetails(responseText: string, statusCode: number): { requestDetails: string, responseDetails: string } {
        try {
            let requestConfig: any = $.extend({},this.ajaxHelperModule.getAjaxHelperConfig().requestConfig);
            // Removing The Auhorization header before logging the request details.
            if (statusCode !== 401) delete requestConfig.headers;

            let requestDetails = Util.maskpII($.extend(true, {}, requestConfig));
            let responseDetails: string = '';

            requestDetails = JSON.stringify(requestDetails).replace(/"/g, "'");
            const options = this.ajaxHelperModule.getAjaxHelperConfig().options;
            if (options && options.encryptit && window.btoa) {
                responseDetails = window.btoa(JSON.stringify(responseText));
            } else {
                responseDetails = Util.maskpII(responseDetails);
            }
            responseDetails = responseDetails ? JSON.stringify(responseDetails).replace(/"/g, "'") : '';
            return {
                requestDetails, responseDetails
            };
        } catch (e) {
            //@ts-ignore
            photoOrg.clientLogger && photoOrg.clientLogger.error({ description: 'LIBRARY:AjaxFailureHelper:captureRequestResponseDetails', errorCode: 'LIBRARY:AjaxFailureHelper', err_desc: e, err_stack: e.stack });
            return {
                requestDetails: '', responseDetails: ''
            };
        }

    }

    private setErrorCode(statusCode: number): void {
        let errorCode = '';
        const options = this.ajaxHelperModule.getAjaxHelperConfig().options;

        if (statusCode === 401) {
            // To handle invalid sharing of URLs, generated after public share login, like : library/photos/pgvw/swmsav/aid/122846030001070/oid/25336616/dc/AUS
            // The assets response is like : {message: "Logged in user does not have permissions to view this social item" ....}
            if (this.failedReponse.jqXHR.responseText.indexOf('Logged in user does not have permissions to view this social item') !== -1) {
                errorCode = 'InvalidAlbumAccessTried';
            } 
            else if(this.failedReponse.jqXHR.responseText.indexOf('MediaTokenRevoked') !== -1){
                errorCode = "MediaTokenRevoked";
            }else {
                errorCode = 'InvalidOauth2Token';
            }
        } else if (statusCode === 0) {
            errorCode = 'HTTPStatus-0';
        } else if (statusCode === 404) {
            errorCode = 'NotFound';
        }
        this.failedReponse.errorCode = errorCode;
        
    }

    private logIt(statusCode: number, responseDetails: string, requestDetails: string){
        const obj: any = {
            description: 'API call Failed',
            httpStatusCode: statusCode, 
            errorCode: this.failedReponse.errorCode,
            Noodle: this.ajaxHelperModule.getAjaxHelperConfig().getNoodle(),
            iterationCount: this.ajaxHelperModule.getAjaxHelperConfig().getIterationCount(),
            errorThrown : this.failedReponse.jqXHR.errorThrown, 
            url: this.ajaxHelperModule.getAjaxHelperConfig().requestConfig.url,
            requestPayload: this.requestConfig.data,
            quickLogger: true, responseDetails, requestDetails
        };
        (this.failedReponse.errorCode === 'InvalidAlbumAccessTried') ? obj.requestDetails = {} : obj.responseDetails = {};
        //debugger;
        console.log(obj)
        //@ts-ignore
        photoOrg.clientLogger && photoOrg.clientLogger.warn(obj);
    }

    private handleStatus401Error() {
        const noodle = this.ajaxHelperModule.getAjaxHelperConfig().getNoodle();
        /*to skip for private share OR Invalid  Sharing of
            post public share login library URL */
        if (this.failedReponse.errorCode === "InvalidOauth2Token") {
            //@ts-ignore
            photoOrg.clientLogger && photoOrg.clientLogger.warn({
                description: 'AjaxFailureHelper : Authentication failed so calling refresh token',
                httpstatusCode: 401, Noodle: noodle, url: this.requestConfig.url
            });           

            OauthClient.fetchToken(AjaxHelperConfig.getCorsProxySettings().url, noodle,
                $.proxy(this.ajaxHelperModule.send.bind(this.ajaxHelperModule, true), this.ajaxHelperModule),
                (redirectToLogin: boolean) => {
                    /* Failure callback */
                    // if any issue with fetch Token just redirect to login page
                    this.ajaxHelperModule.getAjaxHelperConfig().getPromiseRef().reject({
                        errorType : "API_FAILURE",
                        httpStatusCode: 401,
                        errorCode : this.failedReponse.errorCode,
                        apiUrl: this.ajaxHelperModule.getAjaxHelperConfig().requestConfig.url,
                        jqXHR: this.failedReponse.jqXHR, textStatus: this.failedReponse.textStatus,
                        errorThrown: this.failedReponse.errorThrown, noodle,
                        redirectToLogin
                    });
                });
        } else { //this.failedReponse.errorCode == "InvalidAlbumAccessTried"
            //window.dispatchEvent(new CustomEvent("ShowErrorOverlay",{ detail: { noodle: this.ajaxHelperModule.getAjaxHelperConfig().getNoodle()}}));
            this.ajaxHelperModule.getAjaxHelperConfig().getPromiseRef().reject({
                errorType : "API_FAILURE",
                httpStatusCode: 401,
                errorCode : this.failedReponse.errorCode,
                jqXHR: this.failedReponse.jqXHR, textStatus: this.failedReponse.textStatus,
                apiUrl: this.ajaxHelperModule.getAjaxHelperConfig().requestConfig.url,
                errorThrown: this.failedReponse.errorThrown, noodle: this.ajaxHelperModule.getAjaxHelperConfig().getNoodle()
            });
        }
    }

    private invokeSend(requestDetails: string) {        
        this.ajaxHelperModule.getAjaxHelperConfig().incrementIterationCount();
        this.ajaxHelperModule.send();
    }

    private handleStatusZeroError(requestDetails: any) {
        // for status 0 and added for "404" as options call is failing for updated versions
        // of ios devices(got this issue for albums second monthindex call)
        // trying once again after few milliseconds, if status code is 0 or 500 with time out error
        const iterationCount = this.ajaxHelperModule.getAjaxHelperConfig().getIterationCount();
        if (iterationCount === 2
            && AjaxHelperConfig.getCorsProxySettings().iscorsRequired) { // for status 0
            const dataHash: any = { url: encodeURI(this.requestConfig.url), type: this.requestConfig.type };
            if (this.requestConfig.params.data !== undefined) {
                dataHash.data = this.requestConfig.params.data;
            }
            this.requestConfig.params.data = dataHash;
            //@ts-ignore
            photoOrg.clientLogger && photoOrg.clientLogger.warn({
                description: 'AssetFetcher : Triggering CorsProxy Call for url : ' + this.requestConfig.url,
                httpstatusCode: 0, Noodle: this.ajaxHelperModule.getAjaxHelperConfig().getNoodle(),
                url: AjaxHelperConfig.getCorsProxyUrl(), quickLogger: true
            });
            this.ajaxHelperModule.getAjaxHelperConfig().incrementIterationCount();
            AjaxHelperConfig.corsRequested();
            this.requestConfig.type = 'POST';
            this.requestConfig.url = AjaxHelperConfig.getCorsProxyUrl();
            this.requestConfig.data = JSON.stringify(this.requestConfig.params.data);
            this.ajaxHelperModule.send();
        } else if (iterationCount <= 1) {
            OnlineCheckHelper.doOnlineAjaxCall(this.invokeSend.bind(this, requestDetails),
                'Noodle=' + this.ajaxHelperModule.getAjaxHelperConfig().getNoodle(),
                this.onlineAjaxFailureCallback);
        } else {
            this.ajaxHelperModule.getAjaxHelperConfig().getPromiseRef().reject({
                errorType : "API_FAILURE",
                httpStatusCode: 0,
                apiUrl: this.ajaxHelperModule.getAjaxHelperConfig().requestConfig.url,
                jqXHR: this.failedReponse.jqXHR, textStatus: this.failedReponse.textStatus,
                errorThrown: this.failedReponse.errorThrown, noodle: this.ajaxHelperModule.getAjaxHelperConfig().getNoodle()
            });
        }
    }

    private handleStatus404Error(requestDetails: any) {
        const iterationCount = this.ajaxHelperModule.getAjaxHelperConfig().getIterationCount();
        if(AjaxHelperConfig.enableApiHitWithMainHost && iterationCount == 0){
            this.invokeSend(requestDetails);
        } else if ((this.ajaxHelperModule.getAjaxHelperConfig().getIterationCount() === 2) && this.options
            && this.options.retryWithNoodle) {
            // For the third iteration for the projects call, we add the noodle and try again for the last time.
            setTimeout(() => {
                try {
                    this.requestConfig.url += this.requestConfig.url.indexOf('?') > 0 ? '&' : '?';
                    this.requestConfig.url += 'Noodle=' + this.ajaxHelperModule.getAjaxHelperConfig().getNoodle();
                } catch (e) {
                    //@ts-ignore
                    photoOrg.clientLogger && photoOrg.clientLogger.warn({
                        description: 'AssetFetcher : Error while making the projects call for the last iteration',
                        httpstatusCode: 404, Noodle: this.ajaxHelperModule.getAjaxHelperConfig().getNoodle(),
                        url: this.requestConfig.url
                    });
                }
                this.ajaxHelperModule.getAjaxHelperConfig().incrementIterationCount();
                this.ajaxHelperModule.send();
            }, 150);
        } else if (iterationCount <= 1) {
            OnlineCheckHelper.doOnlineAjaxCall(this.invokeSend.bind(this, requestDetails),
                'Noodle=' + this.ajaxHelperModule.getAjaxHelperConfig().getNoodle(),
                this.onlineAjaxFailureCallback);
        } else {
            /** Added to show error overlay for 404 error aswell */
            window.dispatchEvent(new CustomEvent("ShowErrorOverlay",{ detail: { noodle: this.ajaxHelperModule.getAjaxHelperConfig().getNoodle()}}));
            this.ajaxHelperModule.getAjaxHelperConfig().getPromiseRef().reject({
                errorType : "API_FAILURE",
                httpStatusCode: 404,
                apiUrl: this.ajaxHelperModule.getAjaxHelperConfig().requestConfig.url,
                jqXHR: this.failedReponse.jqXHR, textStatus: this.failedReponse.textStatus,
                errorThrown: this.failedReponse.errorThrown, noodle: this.ajaxHelperModule.getAjaxHelperConfig().getNoodle()
            });
        }
    }
    onlineAjaxFailureCallback(){
        console.log('no internet connection')
    }
    
    private handleStatus500Error(responseText: string, requestDetails: string) {
        const iterationCount = this.ajaxHelperModule.getAjaxHelperConfig().getIterationCount();
        if(AjaxHelperConfig.enableApiHitWithMainHost && iterationCount == 0){
            this.invokeSend(requestDetails);
            return;
        } if (iterationCount <= 1 && responseText.indexOf('Timeout while receiving message') !== -1) {
            setTimeout(this.invokeSend.bind(this, requestDetails), 150);
        } else {            
            window.dispatchEvent(new CustomEvent("ShowErrorOverlay",{ detail: { noodle: this.ajaxHelperModule.getAjaxHelperConfig().getNoodle()}}));
            this.ajaxHelperModule.getAjaxHelperConfig().getPromiseRef().reject({
                errorType : "API_FAILURE",
                httpStatusCode: 500,
                apiUrl: this.ajaxHelperModule.getAjaxHelperConfig().requestConfig.url,
                jqXHR: this.failedReponse.jqXHR, textStatus: this.failedReponse.textStatus,
                errorThrown: this.failedReponse.errorThrown, noodle: this.ajaxHelperModule.getAjaxHelperConfig().getNoodle()
            });
            
        }
    }

    private handleStatusCodes(requestDetails: any): void {
        // some time jqr object giving 404 for 401 status codes which are comming from pict service (example)
        switch (this.failedReponse.jqXHR.status) {
            case 500: this.handleStatus500Error(this.failedReponse.jqXHR.responseText, requestDetails); break;
            case 501: this.handleStatus500Error(this.failedReponse.jqXHR.responseText, requestDetails); break;
            case 520: this.handleStatus500Error(this.failedReponse.jqXHR.responseText, requestDetails); break;
            case 404: this.handleStatus404Error(requestDetails); break;
            case 430: this.invokeSend(requestDetails); break;
            case 431: this.invokeSend(requestDetails); break;//for request header fields too large
            case 401: this.handleStatus401Error(); break;// 401 can be for any iteration
            case 0: this.handleStatusZeroError(requestDetails); break;
            default:                
                window.dispatchEvent(new CustomEvent("ShowErrorOverlay",{ detail: { noodle: this.ajaxHelperModule.getAjaxHelperConfig().getNoodle()}}));
                this.ajaxHelperModule.getAjaxHelperConfig().getPromiseRef().reject({
                errorType : "API_FAILURE",
                httpStatusCode: this.failedReponse.jqXHR.status,
                apiUrl: this.ajaxHelperModule.getAjaxHelperConfig().requestConfig.url,
                jqXHR: this.failedReponse.jqXHR, textStatus: this.failedReponse.textStatus,
                errorThrown: this.failedReponse.errorThrown, noodle: this.ajaxHelperModule.getAjaxHelperConfig().getNoodle()
            });
        }
    }
}
